import { render, staticRenderFns } from "./CopyableTableCell.vue?vue&type=template&id=a96cc536&scoped=true"
import script from "./CopyableTableCell.vue?vue&type=script&lang=js"
export * from "./CopyableTableCell.vue?vue&type=script&lang=js"
import style0 from "./CopyableTableCell.vue?vue&type=style&index=0&id=a96cc536&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96cc536",
  null
  
)

export default component.exports